// extracted by mini-css-extract-plugin
module.exports = {"root":"Main-root-30b900853bfc4cab938ee410715fa644","logoContainer":"Main-logoContainer-c6fe5584093376f5dabed03997202b03"};